import API from '../repositories/OnlineCandidate';
import { SET_CONTESTLIST, SET_YEARLIST, SET_ELECTIONLIST, SET_ERROR, SET_CONTEST, SET_CANDIDATESTATEMENTINFO, CLEAR_CONTEST, SET_ELECTION, SET_YEAR, SET_CONTEST_BY_CANDIDATE, SET_LANGUAGE_CODE, SET_SEARCH_INPUT } from './mutations.type';
import { FETCH_CANDIDATELIST, FETCH_CONTESTLIST, FETCH_YEARLIST, FETCH_ELECTIONLIST, FETCH_PUBLISHEDCANDIDATESTATEMENT, SET_CONTEST_USING_SELECTED_CANDIDATE, SET_LANGUAGE, SET_SEARCH } from './actions.type';

export const actions = {
    [SET_CONTEST_USING_SELECTED_CANDIDATE](context, candidate) {
        return new Promise(resolve => {
            context.commit(SET_CONTEST_BY_CANDIDATE, candidate);
            resolve();
        });
    },
    [SET_LANGUAGE](context, language) {
        return new Promise(resolve => {
            context.commit(SET_LANGUAGE_CODE, language);
            resolve();
        })
    },
    [FETCH_YEARLIST](context) {
        return new Promise(resolve => {
            API.getActiveElectionYears() 
                .then(({data}) => {
                    context.commit(SET_YEARLIST, data);
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response.data.errors);
                })
        })
    },
    [FETCH_ELECTIONLIST](context, year) {
        return new Promise(resolve => {
            context.commit(SET_YEAR, year);
            API.getElectionInfoByYear(year) 
                .then(({data}) => {
                    context.commit(SET_ELECTIONLIST, data);
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response.data.errors);
                })
        })
    },
    [FETCH_CONTESTLIST](context, electionId) {
        return new Promise(resolve => {
            context.commit(SET_ELECTION, electionId);
            API.getContestByElectionId(electionId) 
                .then(({data}) => {
                    context.commit(SET_CONTESTLIST, data);
                    if (data.length === 0) {
                        context.commit(CLEAR_CONTEST);
                    }
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response.data.errors);
                })
        })
    },
    [FETCH_CANDIDATELIST](context, contestId) {
        return new Promise(resolve => {
            API.getCandidateAvaliableLanguagesByContestId(contestId) 
                .then(({data}) => {
                    let contest = null;
                    this.state.contestList.forEach(c => {
                        if (c.contestId === contestId) {
                            contest = c;
                        }
                    });
                    data.forEach(statement => {
                        contest.candidates.forEach(candidate => {
                            if (candidate.candidateId === statement.candidateId) {
                                if (candidate.lang === undefined) {
                                    candidate.lang = {};
                                }
                                candidate.lang[statement.language] = statement.status;
                            }
                        })
                    })
                    context.commit(SET_CONTEST, contest, contestId);
                    resolve(contestId);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response.data.errors);
                })
        })
    },
    [FETCH_PUBLISHEDCANDIDATESTATEMENT](context, payload) {
        return new Promise(resolve => {
            let statements = {
                candidateStatements: undefined,
                selectedCandidate: payload.selectedCandidate,
                selectedLanguage: payload.selectedLanguage,
                candidateName: payload.candidateName
            }
            API.getPublishedCandidateStatements(payload.contestId, payload.candidateId)
                .then(({data}) => {
                    statements.candidateStatements = data;
                    context.commit(SET_CANDIDATESTATEMENTINFO, statements);
                    resolve(data);
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response.data.errors);
                })
        })
    },
    [SET_SEARCH](context, payload) {
        return new Promise(resolve => {
            context.commit(SET_SEARCH_INPUT, payload);
            resolve(payload);
        })
    },
}